<template>
  <div v-if="errors" class="invalid-feedback">
    <template v-for="errorItem of errors">
      {{ errorItem }}
    </template>
  </div>
</template>

<script>
export default {
  name: "ErrorsForm",
  props: {
    errors: {
      type: Array
    }
  },
}
</script>

<style>

</style>